/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceForm/BillingCenter/Content/Options/Edit/Content/Empty"
  
}) {
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="No billing center found."
/>
{children}
</React.Fragment>)
}